import axios from "axios";
import { getAuthToken } from "../gridAuthClient";

const BASE_URL = process.env.REACT_APP_PAYMENTAPI_URL;

export async function getUserSubscription({ userId }) {
  try {
    const token = await getAuthToken();
    const { data } = await axios.post(`${BASE_URL}get-subscription-status`, { user_id: userId }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (e) {
    if (e.response?.status === 404) {
      return []; // no paid sub
    }
    throw e;
  }
}
